module.exports = __webpack_public_path__ + "img/Lindsey_Herbert.05c362bb.jpg";